/* ==========================================================================
   HOLY MOLY — JS del tema
   Sin dependencias. Todo se activa solo si el nodo existe en la página.
   ========================================================================== */
(function () {
  'use strict';

  var money = function (cents) {
    var fmt = (window.HM && window.HM.moneyFormat) || '${{amount}}';
    var amount = (cents / 100);
    var parts = amount.toFixed(2).split('.');
    var withSep = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fmt
      .replace('{{amount_no_decimals_with_comma_separator}}', withSep)
      .replace('{{amount_no_decimals}}', withSep)
      .replace('{{amount_with_comma_separator}}', withSep + ',' + parts[1])
      .replace('{{amount}}', withSep + ',' + parts[1]);
  };

  var t = function (key, fallback) {
    return (window.HM && window.HM.strings && window.HM.strings[key]) || fallback;
  };

  /* ---------------------------------------------------------------
     1. AGE GATE — se guarda en cookie de sesión, no en localStorage
  --------------------------------------------------------------- */
  function initAgeGate() {
    var gate = document.querySelector('[data-age-gate]');
    if (!gate) return;
    if (document.cookie.indexOf('hm_age_ok=1') !== -1) { gate.remove(); return; }
    gate.hidden = false;
    document.body.style.overflow = 'hidden';

    gate.querySelector('[data-gate-yes]').addEventListener('click', function () {
      var days = parseInt(gate.getAttribute('data-days') || '30', 10);
      var d = new Date(); d.setTime(d.getTime() + days * 864e5);
      document.cookie = 'hm_age_ok=1;expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
      gate.style.opacity = '0';
      document.body.style.overflow = '';
      setTimeout(function () { gate.remove(); }, 500);
    });

    var no = gate.querySelector('[data-gate-no]');
    if (no) no.addEventListener('click', function () {
      window.location.href = gate.getAttribute('data-exit') || 'https://www.google.com';
    });
  }

  /* ---------------------------------------------------------------
     2. LOS MUNDOS — indicador lateral y color activo
  --------------------------------------------------------------- */
  function initMundos() {
    var wrap = document.querySelector('[data-mundos]');
    if (!wrap || !('IntersectionObserver' in window)) return;
    var mundos = wrap.querySelectorAll('.mundo');
    var dots = document.querySelectorAll('[data-mundos-dots] i');
    var dotsWrap = document.querySelector('[data-mundos-dots]');

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var i = Array.prototype.indexOf.call(mundos, e.target);
        dots.forEach(function (d, j) { d.classList.toggle('is-act', j === i); });
        document.documentElement.style.setProperty('--dotc',
          getComputedStyle(e.target).getPropertyValue('--m-tx'));
        var v = e.target.querySelector('video');
        if (v && v.paused) v.play().catch(function () {});
        // Precarga del siguiente loop
        var next = mundos[i + 1];
        if (next) {
          var nv = next.querySelector('video[preload="none"]');
          if (nv) { nv.setAttribute('preload', 'auto'); nv.load(); }
        }
      });
    }, { threshold: 0.55 });
    mundos.forEach(function (m) { io.observe(m); });

    if (dotsWrap) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { dotsWrap.classList.toggle('is-on', e.isIntersecting); });
      }, { threshold: 0.05 }).observe(wrap);
    }
  }

  /* ---------------------------------------------------------------
     3. CARRITO — añadir por AJAX + drawer
  --------------------------------------------------------------- */
  var Cart = {
    drawer: null,
    open: function () {
      if (!this.drawer) return;
      this.drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var c = this.drawer.querySelector('.drawer__close');
      if (c) c.focus();
    },
    close: function () {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    },
    render: function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });
      document.querySelectorAll('[data-cart-total]').forEach(function (el) {
        el.innerHTML = money(cart.total_price);
      });
      if (!this.drawer) return;
      var body = this.drawer.querySelector('[data-drawer-body]');
      var foot = this.drawer.querySelector('[data-drawer-foot]');
      if (!body) return;

      if (!cart.item_count) {
        body.innerHTML = '<p style="padding:40px 0;text-align:center;font-weight:600">' +
          t('cartEmpty', 'Tu bolsa está vacía por ahora.') + '</p>';
        if (foot) foot.hidden = true;
        return;
      }
      if (foot) foot.hidden = false;

      body.innerHTML = cart.items.map(function (it) {
        var img = it.image
          ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="" loading="lazy" width="76" height="76">'
          : '';
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
        return '<div class="citem" data-key="' + it.key + '">' +
          '<div class="citem__img">' + img + '</div>' +
          '<div>' +
            '<h3>' + it.product_title + '</h3>' +
            '<p class="citem__var">' + variant + '</p>' +
            '<div class="qty qty--sm">' +
              '<button type="button" data-qty="-1" aria-label="Restar">−</button>' +
              '<input type="number" value="' + it.quantity + '" min="0" data-qty-input aria-label="Cantidad">' +
              '<button type="button" data-qty="1" aria-label="Sumar">+</button>' +
            '</div>' +
            '<button type="button" class="citem__rm" data-remove>' + t('remove', 'Quitar') + '</button>' +
          '</div>' +
          '<div class="citem__pr">' + money(it.final_line_price) + '</div>' +
        '</div>';
      }).join('');
    },
    fetchCart: function () {
      var self = this;
      return fetch(window.Shopify.routes.root + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (c) { self.render(c); return c; });
    },
    add: function (formData, btn) {
      var self = this;
      if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = t('adding', 'Añadiendo…'); }
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST', body: formData
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message);
          return self.fetchCart();
        })
        .then(function () { self.open(); })
        .catch(function (err) { alert(err.message || t('addError', 'No se pudo añadir. Intenta de nuevo.')); })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; }
        });
    },
    change: function (key, qty) {
      var self = this;
      return fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          self.render(c);
          if (document.body.classList.contains('template-cart')) window.location.reload();
          return c;
        });
    }
  };

  function initCart() {
    Cart.drawer = document.querySelector('[data-cart-drawer]');

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form || form.hasAttribute('data-no-ajax')) return;
      e.preventDefault();
      Cart.add(new FormData(form), form.querySelector('[type="submit"]'));
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]')) { e.preventDefault(); Cart.fetchCart().then(function(){ Cart.open(); }); return; }
      if (e.target.closest('[data-cart-close]') || e.target.classList.contains('drawer__bg')) { Cart.close(); return; }

      var qa = e.target.closest('[data-quick-add]');
      if (qa) {
        e.preventDefault();
        var fd = new FormData();
        fd.append('id', qa.getAttribute('data-quick-add'));
        fd.append('quantity', 1);
        Cart.add(fd, qa).then(function () {
          if (document.body.classList.contains('template-cart')) window.location.reload();
        });
        return;
      }

      var qtyBtn = e.target.closest('[data-qty]');
      if (qtyBtn) {
        var row = qtyBtn.closest('[data-key]');
        var input = qtyBtn.parentNode.querySelector('[data-qty-input]');
        var delta = parseInt(qtyBtn.getAttribute('data-qty'), 10);
        var next = Math.max(0, parseInt(input.value, 10) + delta);
        if (row) { Cart.change(row.getAttribute('data-key'), next); }
        else { input.value = Math.max(1, next); }
        return;
      }

      var rm = e.target.closest('[data-remove]');
      if (rm) {
        var r = rm.closest('[data-key]');
        if (r) Cart.change(r.getAttribute('data-key'), 0);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { Cart.close(); closeSearch(); }
    });
  }

  /* ---------------------------------------------------------------
     4. BÚSQUEDA PREDICTIVA
  --------------------------------------------------------------- */
  var searchEl, searchTimer;
  function closeSearch() {
    if (searchEl) { searchEl.classList.remove('is-open'); document.body.style.overflow = ''; }
  }
  function initSearch() {
    searchEl = document.querySelector('[data-psearch]');
    if (!searchEl) return;
    var input = searchEl.querySelector('input[name="q"]');
    var out = searchEl.querySelector('[data-psearch-results]');

    document.querySelectorAll('[data-search-open]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        searchEl.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        setTimeout(function () { input.focus(); }, 60);
      });
    });
    searchEl.addEventListener('click', function (e) {
      if (e.target === searchEl || e.target.hasAttribute('data-psearch-close')) closeSearch();
    });

    input.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      searchTimer = setTimeout(function () {
        fetch(window.Shopify.routes.root + 'search/suggest?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,article&resources[limit]=8&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var res = doc.querySelector('[data-psearch-inner]');
            out.innerHTML = res ? res.innerHTML : '';
          })
          .catch(function () { out.innerHTML = ''; });
      }, 250);
    });
  }

  /* ---------------------------------------------------------------
     5. GALERÍA DE PRODUCTO
  --------------------------------------------------------------- */
  function initGallery() {
    var gal = document.querySelector('[data-gallery]');
    if (!gal) return;
    var main = gal.querySelector('[data-gallery-main]');
    gal.querySelectorAll('[data-gallery-thumb]').forEach(function (th) {
      th.addEventListener('click', function () {
        var i = th.getAttribute('data-pane');
        gal.querySelectorAll('[data-gallery-thumb]').forEach(function (x) { x.classList.remove('is-act'); });
        th.classList.add('is-act');
        if (!main) return;
        main.querySelectorAll('.gal__pane').forEach(function (pane) {
          var on = pane.getAttribute('data-pane') === i;
          pane.classList.toggle('is-act', on);
          if (!on) { var vid = pane.querySelector('video'); if (vid) vid.pause(); }
        });
      });
    });
  }

  /* ---------------------------------------------------------------
     6. VARIANTES
  --------------------------------------------------------------- */
  function initVariants() {
    var root = document.querySelector('[data-variants]');
    if (!root) return;
    var data = JSON.parse(root.querySelector('[data-variants-json]').textContent);
    var idInput = root.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var btn = root.querySelector('[type="submit"]');

    function select(variantId) {
      var v = data.filter(function (x) { return String(x.id) === String(variantId); })[0];
      if (!v) return;
      idInput.value = v.id;
      if (v.image) {
        var mainImg = document.querySelector('[data-gallery-main] .gal__pane.is-act img') ||
                      document.querySelector('[data-gallery-main] img');
        if (mainImg) { mainImg.removeAttribute('srcset'); mainImg.removeAttribute('sizes'); mainImg.src = v.image; }
      }
      if (priceEl) {
        var html = '<span class="' + (v.compare_at_price > v.price ? 'price--sale' : '') + '">' + money(v.price) + '</span>';
        if (v.compare_at_price > v.price) html += '<s>' + money(v.compare_at_price) + '</s>';
        priceEl.innerHTML = html;
      }
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? t('addToCart', 'Añadir a la bolsa') : t('soldOut', 'Agotado');
      }
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      }
    }

    /* Selección por opción: cada botón fija un valor de su propia opción
       y buscamos la variante que coincide en todas. */
    var opts = root.querySelectorAll('[data-opt-index]');
    if (opts.length) {
      var chosen = [];
      opts.forEach(function (el) {
        var i = parseInt(el.getAttribute('data-opt-index'), 10);
        if (el.classList.contains('is-act')) chosen[i] = el.getAttribute('data-opt-value');
      });

      function label(i) {
        var el = root.querySelector('[data-opt-current="' + i + '"]');
        if (el) el.textContent = chosen[i] ? '· ' + chosen[i] : '';
      }
      function disponible(i, value) {
        // ¿existe alguna variante disponible con este valor y el resto de lo elegido?
        return data.some(function (v) {
          if (v.options[i] !== value || !v.available) return false;
          for (var j = 0; j < chosen.length; j++) {
            if (j !== i && chosen[j] && v.options[j] !== chosen[j]) return false;
          }
          return true;
        });
      }
      function refrescar() {
        opts.forEach(function (el) {
          var i = parseInt(el.getAttribute('data-opt-index'), 10);
          var val = el.getAttribute('data-opt-value');
          el.classList.toggle('is-act', chosen[i] === val);
          el.classList.toggle('is-off', !disponible(i, val));
        });
        chosen.forEach(function (_, i) { label(i); });

        var match = data.filter(function (v) {
          return chosen.every(function (c, i) { return !c || v.options[i] === c; });
        })[0];
        if (match) select(match.id);
      }

      opts.forEach(function (el) {
        el.addEventListener('click', function () {
          chosen[parseInt(el.getAttribute('data-opt-index'), 10)] = el.getAttribute('data-opt-value');
          refrescar();
        });
      });
      refrescar();
    }

    var sel = root.querySelector('[data-variant-select]');
    if (sel) sel.addEventListener('change', function () { select(sel.value); });
  }

  /* ---------------------------------------------------------------
     7. FILTROS DE COLECCIÓN
  --------------------------------------------------------------- */
  function initFacets() {
    document.querySelectorAll('[data-facet]').forEach(function (f) {
      var btn = f.querySelector('.facet__btn');
      var panel = f.querySelector('.facet__panel');
      if (!btn || !panel) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        document.querySelectorAll('.facet__panel').forEach(function (p) { if (p !== panel) p.hidden = true; });
        panel.hidden = !panel.hidden;
      });
      panel.addEventListener('click', function (e) { e.stopPropagation(); });
    });
    document.addEventListener('click', function () {
      document.querySelectorAll('.facet__panel').forEach(function (p) { p.hidden = true; });
    });
    var form = document.querySelector('[data-facet-form]');
    if (form) {
      form.addEventListener('change', function () { form.submit(); });
    }
    var sort = document.querySelector('[data-sort]');
    if (sort) sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------------------------------------------------------------
     8. QUIZ — «Que Holy me guíe»
  --------------------------------------------------------------- */
  function initQuiz() {
    var app = document.querySelector('[data-quiz]');
    if (!app) return;
    var steps = Array.prototype.slice.call(app.querySelectorAll('[data-quiz-step]'));
    var bar = app.querySelector('[data-quiz-bar]');
    var answers = {};
    var i = 0;

    function show(n) {
      i = n;
      steps.forEach(function (s, j) { s.hidden = j !== n; });
      if (bar) bar.style.width = ((n) / steps.length * 100) + '%';
      window.scrollTo({ top: app.offsetTop - 90, behavior: 'smooth' });
    }

    app.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-quiz-opt]');
      if (opt) {
        answers[opt.closest('[data-quiz-step]').getAttribute('data-key')] = opt.getAttribute('data-value');
        if (i + 1 < steps.length) { show(i + 1); }
        else { finish(); }
        return;
      }
      if (e.target.closest('[data-quiz-back]')) { if (i > 0) show(i - 1); }
    });

    function finish() {
      if (bar) bar.style.width = '100%';
      var tags = Object.keys(answers).map(function (k) { return answers[k]; }).filter(Boolean);
      var base = app.getAttribute('data-results-url') || (window.Shopify.routes.root + 'collections/all');
      var url = base + (base.indexOf('?') > -1 ? '&' : '?') + 'filter.p.tag=' + tags.map(encodeURIComponent).join('&filter.p.tag=');
      window.location.href = url;
    }

    show(0);
  }

  /* ---------------------------------------------------------------
     9. MENÚ MÓVIL
  --------------------------------------------------------------- */
  function initMobileNav() {
    var burger = document.querySelector('[data-burger]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!burger || !nav) return;
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }

  /* --------------------------------------------------------------- */
  function init() {
    if (!window.Shopify) window.Shopify = { routes: { root: '/' } };
    if (!window.Shopify.routes) window.Shopify.routes = { root: '/' };
    initAgeGate();
    initMundos();
    initCart();
    initSearch();
    initGallery();
    initVariants();
    initFacets();
    initQuiz();
    initMobileNav();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.HMCart = Cart;
})();
